import { avenirNextDemi } from "@/styles/fonts";
import {twMerge} from "tailwind-merge";
import Link from "next/link";

const classBtn = [avenirNextDemi.className,
    "block sm:inline text-white text-center rounded-[6px] border",
    "my-[5px] sm:my-0 sm:mr-[15px] md:mr-[20px]",
    "sm:w-auto",
    "px-[15px] py-[5px] md:px-[30px] md:py-[9px]",
    "text-[13px] md:text-[15px] "];

export function AdbeatButton({
    text, onClick, href, className, target, name,
    id, type = "button", disabled
}: {
    text: string,
    className?: string
    onClick?: React.MouseEventHandler<HTMLButtonElement>,
    href?: string,
    target?: string,
    type?: "button" | "submit" | "reset",
    name?: string,
    id?: string,
    disabled?: boolean,
}) {
    const buttonClass = twMerge(classBtn.join(" "), className);
    if (href) {
        return (<Link className={buttonClass} href={href} target={target}>{text}</Link>);
    } else {
        return (<button
            name={name}
            id={id}
            type={type || "button"}
            className={buttonClass}
            onClick={onClick}
            disabled={disabled}>{text}</button>);
    }
}